import EventBus from '@/eventBus.js'

export default {
  methods: {
    listenLineUpdate() {
      EventBus.$on('update-line-blocks', this.onUpdateBlocks)
    },
    unlistenLineUpdate() {
      EventBus.$off('update-line-blocks', this.onUpdateBlocks)
    },
    onUpdateBlocks(updatedBlocks) {
      const oldCanvasBlocks = JSON.parse(JSON.stringify(this.dataCanvasBlocks))
      const newCanvasBlocks = { ...oldCanvasBlocks }
      updatedBlocks.forEach((block) => {
        newCanvasBlocks[block.id] = {
          ...newCanvasBlocks[block.id],
          ...block,
        }
      })
      this.updateCanvasBlocks(newCanvasBlocks, this.slideActive.id)
      this.backupBlocks(oldCanvasBlocks, newCanvasBlocks, updatedBlocks)
    },
  },
}
